<template>
        <div class="col-1.5 m-3" >
      <span >
    <select class="custom-select" v-on:input="$emit('input', $event.target.value)">
<option :value=null selected>Filtra per servizio</option>
  <option v-for="servizio in servizi"
          :key="servizio.id"
          :value="servizio.id"
           >
          <span >{{servizio.nome}}</span></option>
</select></span>
         <!-- <span class="navitem"
         v-for="servizio in servizi"
          :key="servizio.id"          >
          <span @click="goTodetail(servizio.id)">{{servizio.nome}}</span>
        </span> -->
    </div>
</template>

<script>
import ServiziDataService from '@/service/ServiziDataService.js'

export default {
  name: 'filtroServizio',
  props: ['value'],
  data () {
    return {
      codiceComune: sessionStorage.getItem('comunelog'),
      servizi: []

    }
  },
  methods: {

    caricaServizi (idC) {
      ServiziDataService
        .getServiziByCommuneId(idC)
        .then(response => {
          console.log(response.data)
          this.servizi = response.data

          console.log('servizi', this.servizi)
        })
        .catch(e => {
          console.log(e)
        })
    }
  },
  mounted () {
    if (!this.codiceComune) {
      this.caricaServizi(this.$route.params.cid)
    } else {
      this.codiceComune = sessionStorage.getItem('comunelog')
      this.caricaServizi(this.codiceComune)
    }
  },
  watch: {
    codiceComune: function (cdm) {
      console.log('rot -->', cdm)
      this.caricaServizi(cdm)
    }

  }
}
</script>
